import { Translatable } from './_generatedTypes.g';

export type LanguageCode = 'NL' | 'EN';

type LocaleCode = 'nl-NL' | 'en-GB';

type TranslatableReactNode<TRenderable> = {
    [L in LanguageCode]: TRenderable;
}

interface ITranslatorExceptStrings {
    //Deze interface deugt niet.  Het beoogd gebruik overal in de applicatie is t[key], maar indien key niet statisch bekend is, 
    //is dat van type "een van de types van de translator props" aka Translator[keyof Translator] - maar dat is een
    //mengeling van strings en de methods hierbeneden, een vrij gestoorde combo.  Dat dat ueberhaupt nog compileert
    //kan eigenlijk alleen omdat de React types vermoedelijk onterecht allemaal rommel als input accepteren, maar soms
    //levert het wel hele rare intellisense of typescript fouten op.
    readonly languageCode: LanguageCode;
    readonly localeCode: LocaleCode;
    translate<TRenderable>(translatable: TranslatableReactNode<TRenderable>): TRenderable;
    eraseElectionWarning: { (electionName: Translatable): string };
    votingResultForElection(electionName: Translatable): string;
    votingRightForElection(electionName: Translatable): string;
    formatTurnout(turnout: number, langCode: LocaleCode, postfix: string): string;
    editElection(name: Translatable): string;
    columnDescription: { (columnTitle: string, lang: string, maxLength: number): string };
    confirmMakePartyAdmin: { (userName: string, partyName: Translatable): string };
}

export type TranslatorKeys =
    'Deleted party successfully'
    | 'Something went wrong while attempting to delete this party'
    | 'Deleting party...'
    | 'Options'
    | 'This election is not visible to voters yet'
    | 'You are not a voter in this election'
    | 'View this election'
    | 'Illegal change'
    | 'Revoke'
    | 'Not applicable'
    | 'Search voters for this election'
    | 'Voters'
    | 'Non-voters'
    | 'Add administrator to party'
    | 'Done adding candidates'
    | 'Add candidates'
    | 'I want to be a candidate'
    | 'Create'
    | 'Add'
    | 'Vote for '
    | 'Loading...'
    | 'Back'
    | 'Logout'
    | 'Please select your institution'
    | 'Confirm vote'
    | 'Confirm blank vote'
    | 'You are logged in'
    | 'The elections visible to you are'
    | 'Name'
    | 'Address'
    | 'Postal code and town'
    | 'Country'
    | 'Date of birth'
    | 'Email address'
    | 'Do you have questions about the elections?'
    | 'Candidates'
    | 'Election'
    | 'Elections'
    | 'Party'
    | 'Parties'
    | 'Candidate'
    | 'Slogan'
    | 'Also electable in'
    | 'Also electable in (NL, max. 200 characters)'
    | 'Also electable in (EN, max. 200 characters)'
    | 'Election text'
    | 'Photograph'
    | 'Edit candidate data'
    | 'Delete candidate data'
    | 'Vote'
    | 'Votes'
    | 'Voting...'
    | 'You voted in this election. Thank you.'
    | 'Voting failed, the election has closed.'
    | 'Voting failed, you already voted in this election.'
    | 'Voting failed; reload the page and try again.'
    | 'Voted'
    | 'User name'
    | 'Password'
    | 'Log in'
    | 'Send log-in link'
    | 'Login failed; please check your user name and password.'
    | 'Logging in...'
    | 'Sending log-in link...'
    | 'Page could not be found.'
    | 'Go to the main page'
    | 'No candidates have been registered for this election yet.'
    | 'No parties have been registered for this election yet.'
    | 'No candidates have been registered for this party yet.'
    | 'Blank vote'
    | 'Are you sure you want to issue a blank vote?'
    | 'Candidacy'
    | 'Not yet open'
    | 'Open'
    | 'Closed'
    | 'Status'
    | 'This election is not yet open.'
    | 'This election is already closed. Editing is not allowed.'
    | 'Admin functionality'
    | 'Name (NL)'
    | 'Name (EN)'
    | 'Description'
    | 'Description (NL, max. 4000 characters)'
    | 'Description (EN, max. 4000 characters)'
    | 'Seat count'
    | 'Save'
    | 'Reset'
    | 'Your changes were successfully saved.'
    | 'Deletion completed'
    | 'Are you sure you want to delete this candidate?'
    | 'Saving...'
    | 'Deleting...'
    | 'Deleted successfully'
    | 'Your changes were not saved, because someone else edited the same election in the meantime. Copy your changes to some other window, reload the page and try again.'
    | 'Note: if the election is open parties and/or candidates can not be edited'
    | 'An error occurred during saving.'
    | 'An error occurred during the deletion.'
    | 'It is not clear if the import was successful. Please wait a few minutes and use an export to verify if the data is present.'
    | 'Home'
    | 'Turnout'
    | 'Link to more party-specific information (must start with http:// or https://)'
    | 'Visit campaign page'
    | 'View mode'
    | 'Edit mode'
    | 'Welcome to the elections!'
    | 'Use the button below to log in.'
    | 'Use your email address to log in.'
    | 'Notify involved'
    | 'Target Group'
    | 'All Voters'
    | 'Message'
    | 'Reply To E‑mail Address'
    | 'Send'
    | 'Message has been queued and will be sent'
    | 'Message could not be queued'
    | 'Delivering message...'
    | 'Edit'
    | 'Delete'
    | 'Approve my candidacy'
    | 'Blank votes'
    | 'Total vote count'
    | 'Candidate vote count'
    | 'Manage accounts'
    | 'Import and/or update accounts'
    | 'Parsing'
    | 'Parsing succeeded'
    | 'Parsing error'
    | 'Manage elections'
    | 'Import elections'
    | 'Election Code'
    | 'Manage parties'
    | 'Import parties'
    | 'Manage candidates'
    | 'Import candidates'
    | 'Position'
    | 'Party code'
    | 'Login name'
    | 'Manage party admins'
    | 'Import party admins'
    | 'Manage voting rights'
    | 'Import voting rights'
    | 'Party url'
    | 'Order'
    | 'Subject'
    | 'Import'
    | 'Search party/candidate'
    | 'Search candidate'
    | 'Search election'
    | 'Clear search field'
    | 'Text'
    | 'Date and time (UTC)'
    | 'Number'
    | 'Yes/No'
    | 'Yes'
    | 'No'
    | 'Column'
    | 'Language'
    | 'Format'
    | 'Required'
    | 'Account'
    | 'Accounts'
    | 'Url (including http(s)://)'
    | 'Party admin'
    | 'Party admins'
    | 'Voting right'
    | 'Voting rights'
    | 'Voting result'
    | 'Download all past voting results (MsExcel)'
    | 'Download turnout results (MsExcel)'
    | 'Download all history (MsExcel)'
    | 'Export election data'
    | 'Export seat distribution'
    | 'Export account data'
    | 'Additional text'
    | 'Administrators log in here'
    | 'Select input file'
    | 'Parse data'
    | 'Choose image file'
    | 'The data from the file is added'
    | 'Could not erase this election because it is currently open'
    | 'Could not erase this election because it does not exist anymore'
    | 'Election is being erased...'
    | 'Election was successfully erased'
    | 'Erasing this election failed'
    | 'Number added'
    | 'Number changed'
    | 'Changed'
    | 'No results found'
    | 'You have voted! You can log out now.'
    | 'An overview appears for reviewing the data'
    | 'Choose an Excel document with'
    | 'to upload'
    | 'If the institution authorized you to edit your party’s details, this screen includes a button ‘Edit’. This option is only available '
    | 'before the election opens'
    | 'Editing your party’s information'
    | 'The Excel document contains one '
    | 'per row'
    | 'Click \'Save\' to actually import the data'
    | 'Photo must be in JPG format with a maximum file size of 1MB'
    | 'Verify that you selected the right candidate and click \'Confirm vote\'.'
    | 'Workflow importing '
    | 'Use the links below the institution logo to switch languages and to log out'
    | 'The Excel document can\'t have a headerrow with e.g. column names'
    | 'When you are done editing, click ‘Save’ to confirm your changes.'
    | 'The columns are in the above defined order'
    | '. Clicking the button will allow you to edit the party’s descriptions (in Dutch and English) and enter the url of the party’s website.'
    | 'To find the candidate you want to vote for, enter a part of his/her name, slogan or promotional text.'
    | 'This screen presents information about the selected candidate.'
    | 'Requirements for the Excel document:'
    | 'Click \'Parse data\''
    | 'Select the'
    | 'you want to vote for or click ‘Blank vote’ if you want to issue a blank vote'
    | 'There are no elections open right now for which you have voting right.'
    | 'If you believe this to be incorrect, please contact us.'
    | 'Download (MsExcel file)'
    | 'Usage history'
    | 'candidate'
    | 'party with the candidate'
    | 'Show parties or candidates in random order'
    | 'Candidates System'
    | 'Party System'
    | 'Note: party- or candidates-system can not be set because the election already has parties and\/or candidates'
    | 'Only use letters or numbers for this field'
    | 'If you are unable to log in, please contact us via'
    | 'Contact us via'
    | 'Duplicate this election'
    | 'Logo'
    | 'Add elections'
    | 'Candidacy open'
    | 'Candidacy closed'
    | 'Visible from date'
    | 'Open date'
    | 'Closing date'
    | 'Visible until date'
    | 'MM/dd/yyyy HH:mm'
    | 'Add Parties'
    | 'Add My Party'
    | 'Phone'
    | 'Time'
    | 'If username is filled, the candidate can edit his or her own data if logged in with this username'
    | 'List order'
    | 'Majority of votes'
    | 'My candidacy data'
    | 'During the nomination, information about the candidate can be added via the edit button. As a candidate, you must approve your candidacy via the button \'Approve my candidacy\''
    ;

export type Translator = Readonly<Record<TranslatorKeys, string>> & ITranslatorExceptStrings;

function translate<TRenderable>(this: Translator, translatable: TranslatableReactNode<TRenderable>): TRenderable {
    return translatable[this.languageCode];
}

const nlTranslator: Translator = {
    'Deleting party...': 'Bezig met verwijderen van partij...',
    'Something went wrong while attempting to delete this party': 'Er ging iets mis tijdens het verwijderen van deze partij',
    'Deleted party successfully': 'Verwijderen partij geslaagd',
    'Options': 'Opties',
    'This election is not visible to voters yet': 'Deze verkiezing is nog niet zichtbaar voor stemmers',
    'You are not a voter in this election': 'U bent geen stemmer in deze verkiezing',
    'View this election': 'Bekijk deze verkiezing',
    'Illegal change': 'Ongeldige wijziging',
    'Revoke': 'Intrekken',
    languageCode: 'NL',
    localeCode: 'nl-NL',
    translate: translate,
    'Not applicable': 'Niet van toepassing',
    'Search voters for this election': 'Zoek naar stemmers binnen deze verkiezing',
    'Voters': 'Stemmers',
    'Non-voters': 'Niet-stemmers',
    'Add administrator to party': 'Partijbeheerder toevoegen',
    'Done adding candidates': 'Klaar met toevoegen',
    'Add candidates': 'Kandidaten toevoegen',
    'I want to be a candidate': 'Ik wil me kandidaat stellen',
    'Create': 'Aanmaken',
    'Candidacy open': 'Kandidaatstelling open',
    'Candidacy closed': 'Kandidaatstelling gesloten',
    'Closing date': 'Open tot',
    'Open date': 'Open vanaf',
    'Visible from date': 'Zichtbaar vanaf',
    'Visible until date': 'Zichtbaar tot',
    'Add': 'Toevoegen',
    'Add elections': 'Verkiezingen toevoegen',
    'Vote for ': 'Stemmen voor ',
    'Loading...': 'Laden...',
    'Back': 'Terug',
    'Logout': 'Uitloggen',
    'Please select your institution': 'Kies uw instelling',
    'Confirm vote': 'Stem bevestigen',
    'Confirm blank vote': 'Blanco stem bevestigen',
    'You are logged in': 'U bent ingelogd',
    'The elections visible to you are': 'U heeft toegang tot de volgende verkiezingen',
    'Name': 'Naam',
    'Address': 'Adres',
    'Postal code and town': 'Postcode en plaats',
    'Country': 'Land',
    'Date of birth': 'Geboortedatum',
    'Email address': 'E‑mailadres',
    'Do you have questions about the elections?': 'Heeft u vragen over de verkiezingen?',
    'Candidates': 'Kandidaten',
    'Election': 'Verkiezing',
    'Elections': 'Verkiezingen',
    'Party': 'Partij',
    'Parties': 'Partijen',
    'Candidate': 'Kandidaat',
    'Slogan': 'Slogan',
    'Also electable in': 'Ook verkiesbaar in',
    'Also electable in (NL, max. 200 characters)': 'Ook verkiesbaar in (NL, 200 karakters max)',
    'Also electable in (EN, max. 200 characters)': 'Ook verkiesbaar in (EN, 200 karakters max)',
    'Photograph': 'Foto',
    'Edit candidate data': 'Kandidaatgegevens bewerken',
    'Delete candidate data': 'Kandidaatgegevens verwijderen',
    'Deletion completed': 'Verwijdering is gereed',
    'Election text': 'Verkiezingstekst',
    columnDescription: (column, lang, maxLength) => `${column} (${lang}, ${maxLength} karakters max.)`,
    'Vote': 'Stem',
    'Votes': 'Stemmen',
    'Voting...': 'Stemmen...',
    'You voted in this election. Thank you.': 'U heeft gestemd in deze verkiezing. Dank u.',
    'Voted': 'Gestemd',
    'Voting failed, the election has closed.': 'Stemmen niet gelukt, de verkiezing is gesloten.',
    'Voting failed, you already voted in this election.': 'Stemmen niet gelukt, u heeft al gestemd in deze verkiezing.',
    'Voting failed; reload the page and try again.': 'Stemmen niet gelukt; herlaad de pagina en probeer het nog een keer.',
    'User name': 'Gebruikersnaam',
    'Password': 'Wachtwoord',
    'Log in': 'Inloggen',
    'Send log-in link': 'Inloglink versturen',
    'Login failed; please check your user name and password.': 'Inloggen niet gelukt; controleer uw gebruikersnaam en wachtwoord.',
    'Logging in...': 'Inloggen...',
    'Sending log-in link...': 'Inloglink versturen...',
    'Page could not be found.': 'Pagina kon niet worden gevonden.',
    'Go to the main page': 'Ga naar de hoofdpagina',
    'No parties have been registered for this election yet.': 'Er zijn nog geen partijen geregistreerd voor deze verkiezing',
    'No candidates have been registered for this election yet.': 'Er zijn nog geen kandidaten geregistreerd voor deze verkiezing.',
    'No candidates have been registered for this party yet.': 'Er zijn nog geen kandidaten geregistreerd voor deze partij.',
    'Blank vote': 'Blanco stem',
    'Are you sure you want to delete this candidate?': 'Weet u zeker dat u deze kandidaat wilt verwijderen?',
    'Are you sure you want to issue a blank vote?': 'Weet u zeker dat u een blanco stem wilt uitbrengen?',
    'Candidacy': 'Kandidaatstelling',
    'Not yet open': 'Nog niet open',
    'Open': 'Open',
    'Closed': 'Gesloten',
    'Status': 'Status',
    'This election is not yet open.': 'Deze verkiezing is nog niet open.',
    'This election is already closed. Editing is not allowed.': 'Deze verkiezing is al gesloten. Bewerken is niet mogelijk.',
    'Admin functionality': 'Admin-functionaliteit',
    editElection: (name: Translatable) => `${name.NL} bewerken`,
    'Name (NL)': 'Naam (NL)',
    'Name (EN)': 'Naam (EN)',
    'Description': 'Beschrijving',
    'Description (NL, max. 4000 characters)': 'Beschrijving (NL, 4000 karakters max.)',
    'Description (EN, max. 4000 characters)': 'Beschrijving (EN, 4000 karakters max.)',
    'Seat count': 'Aantal zetels',
    'Save': 'Opslaan',
    'Delete': 'Verwijderen',
    'Approve my candidacy': 'Keur mijn kandidaatstelling goed',
    'Reset': 'Reset',
    'Your changes were successfully saved.': 'Uw wijzigingen zijn succesvol opgeslagen.',
    'Saving...': 'Opslaan...',
    'Deleting...': 'Wordt verwijderd...',
    'Deleted successfully': 'Verwijderen is gelukt',
    'Your changes were not saved, because someone else edited the same election in the meantime. Copy your changes to some other window, reload the page and try again.': 'Uw wijzigen zijn niet opgeslagen, want iemand anders heeft dezelfde verkiezing in de tussentijd gewijzigd. Kopieer uw wijzigingen naar een ander venster, herlaad de pagina en probeer het nog een keer.',
    'Note: if the election is open parties and/or candidates can not be edited': 'NB: wanneer een verkiezing eenmaal geopend is kunnen partijen en/of kandidaten niet meer worden bewerkt',
    'An error occurred during saving.': 'Er is een fout opgetreden tijdens het opslaan.',
    'An error occurred during the deletion.': 'Er is een fout opgetreden tijdens het verwijderen.',
    'It is not clear if the import was successful. Please wait a few minutes and use an export to verify if the data is present.': 'Het is niet duidelijk of het importeren gelukt is. Wacht een aantal minuten en gebruik een export om te verifiëren of de gegevens aanwezig zijn.',
    'Home': 'Home',
    'Turnout': 'Opkomst',
    formatTurnout: (turnout: number, langCode: LocaleCode, postfix: string) =>
        `${Number(turnout.toFixed(2)).toLocaleString(langCode)}%${postfix}`,
    'Link to more party-specific information (must start with http:// or https://)': 'Koppeling naar partijspecifieke informatie (moet beginnen met http:// of https://)',
    'Visit campaign page': 'Pagina bezoeken',
    'View mode': 'Weergavemodus',
    'Edit mode': 'Bewerkmodus',
    'Welcome to the elections!': 'Welkom bij de verkiezingen!',
    'Use the button below to log in.': 'Gebruik onderstaande knop om in te loggen.',
    'Use your email address to log in.': 'Gebruik je e‑mailadres om in te loggen.',
    'Notify involved': 'E‑mail betrokkenen',
    'Target Group': 'Doelgroep',
    'All Voters': 'Kiesgerechtigden',
    'Message': 'Inhoud van bericht',
    'Reply To E‑mail Address': 'Antwoordemailadres',
    'Send': 'Versturen',
    'Message has been queued and will be sent': 'Bericht is opgeslagen en zal worden verstuurd',
    'Message could not be queued': 'Bericht kon niet worden opgeslagen',
    'Delivering message...': 'Bezig met doorsturen...',
    'Edit': 'Bewerken',
    'Blank votes': 'Blanco stemmen',
    'Total vote count': 'Totaal aantal stemmen',
    'Candidate vote count': 'Aantal stemmen op kandidaten',
    'Manage accounts': 'Beheer accounts',
    'Import and/or update accounts': 'Importeren en/of bijwerken accounts',
    'Parsing': 'Controleren',
    'Parsing succeeded': 'Controle gelukt',
    'Parsing error': 'Data is niet in orde',
    'Manage elections': 'Beheer verkiezingen',
    'Import elections': 'Importeren verkiezingen',
    'Election Code': 'Verkiezingscode',
    'Manage parties': 'Beheer partijen',
    'Import parties': 'Importeer partijen',
    'Manage candidates': 'Beheer kandidaten',
    'Import candidates': 'Importeer kandidaten',
    'Position': 'Positie',
    'Party code': 'Partijcode',
    'Login name': 'Inlog naam',
    'Manage party admins': 'Beheer partijbeheerders',
    'Import party admins': 'Importeren partijbeheerders',
    'Manage voting rights': 'Beheer stemrechten',
    'Import voting rights': 'Importeren stemrechten',
    'Party url': 'Partij link',
    'Order': 'Volgorde',
    'Subject': 'Onderwerp',
    'Import': 'Importeren',
    eraseElectionWarning: name => `Weet u zeker dat u ${name.NL} wilt wissen?\n\nlet op: dit verwijdert eveneens de bijbehorende kandidaat- en partijgegevens.\n\nU kunt deze actie niet ongedaan maken!`,
    'Search party/candidate': 'Zoek partij/kandidaat',
    'Search candidate': 'Zoek kandidaat',
    'Search election': 'Zoek verkiezing',
    'Clear search field': 'Zoekveld leegmaken',
    'Text': 'Tekst',
    'Date and time (UTC)': 'Datum en tijd (UTC)',
    'Number': 'Getal',
    'Yes/No': 'Ja/Nee',
    'Yes': 'Ja',
    'No': 'Nee',
    'Column': 'Kolom',
    'Language': 'Taal',
    'Format': 'Formaat',
    'Required': 'Verplicht',
    'Account': 'Account',
    'Accounts': 'Accounts',
    'Url (including http(s)://)': 'Url (inclusief http(s)://)',
    'Party admin': 'Partijbeheerder',
    'Party admins': 'Partijbeheerders',
    'Voting right': 'Stemrecht',
    'Voting rights': 'Stemrechten',
    votingRightForElection: (electionName: Translatable) => `Stemrecht voor ${electionName.NL}`,
    votingResultForElection: (electionName: Translatable) => `Stemuitslag voor ${electionName.NL}`,
    'Voting result': 'Stemuitslag',
    'Download all past voting results (MsExcel)': 'Download stemuitslagen van alle afgelopen verkiezingen (MsExcel)',
    'Download turnout results (MsExcel)': 'Download opkomstresultaten (MsExcel)',
    'Download all history (MsExcel)': 'Download alle historie (MsExcel)',
    'Export election data': 'Exporteer gegevens van de verkiezingen',
    'Export seat distribution': 'Exporteer zetelverdeling',
    'Export account data': 'Exporteer accountgegevens',
    'Additional text': 'Vrije tekst',
    'Administrators log in here': 'Beheerders loggen hier in',
    'Select input file': 'Invoerbestand kiezen',
    'Parse data': 'Controleer data',
    'Choose image file': 'Afbeelding kiezen',
    'The data from the file is added': 'De gegevens uit het bestand zijn toegevoegd',
    'Election was successfully erased': 'Verkiezing is gewist',
    'Election is being erased...': 'Verkiezing aan het wissen...',
    'Could not erase this election because it does not exist anymore': 'Kon verkiezing niet wissen omdat deze niet meer bestaat',
    'Could not erase this election because it is currently open': 'Kon verkiezing niet wissen omdat deze momenteel geopend is',
    'Erasing this election failed': 'Verkiezing wissen niet gelukt',
    'Number added': 'Aantal toegevoegd',
    'Number changed': 'Aantal gewijzigd',
    'Changed': 'Wijzigingen',
    'No results found': 'Geen resultaten gevonden',
    'You have voted! You can log out now.': 'U hebt gestemd! U kunt nu uitloggen.',
    'An overview appears for reviewing the data': 'Er verschijnt een overzicht van de gegevens ter controle',
    'Choose an Excel document with': 'Kies een Excel-document met',
    'to upload': 'om te uploaden',
    'If the institution authorized you to edit your party’s details, this screen includes a button ‘Edit’. This option is only available ': 'Als de instelling u heeft gemachtigd om de gegevens van uw partij te bewerken, bevat dit scherm een knop ‘Bewerken’. Deze optie is alleen beschikbaar ',
    'before the election opens': 'voordat de verkiezing open is',
    'Editing your party’s information': 'Partijgegevens bijwerken',
    'The Excel document contains one ': 'Het Excel-document bevat 1 ',
    'per row': 'per rij',
    'Click \'Save\' to actually import the data': 'Klik op opslaan om de gegevens daadwerkelijk te importeren',
    'Photo must be in JPG format with a maximum file size of 1MB': 'Foto moet in JPG-formaat zijn met een maximum bestandsgrootte van 1MB',
    'Verify that you selected the right candidate and click \'Confirm vote\'.': 'Controleer dat u de bedoelde kandidaat hebt geselecteerd en klik op ‘Stem bevestigen’.',
    'Workflow importing ': 'Werkwijze importeren ',
    'Use the links below the institution logo to switch languages and to log out': 'Gebruik de links onder het logo om te wisselen van taal of uit te loggen',
    'The Excel document can\'t have a headerrow with e.g. column names': 'Het Excel-document mag geen headerrij met bijvoorbeeld kolomnamen bevatten',
    'When you are done editing, click ‘Save’ to confirm your changes.': 'Wanneer u klaar bent met bewerken, kies ‘Opslaan’.',
    'The columns are in the above defined order': 'De kolommen moeten in bovenstaande volgorde staan',
    '. Clicking the button will allow you to edit the party’s descriptions (in Dutch and English) and enter the url of the party’s website.': '. Wanneer u op deze knop drukt, kunt u de omschrijvingstekst (in Nederlands en Engels) van uw partij bewerken, en een link naar de website van de partij ingeven.',
    'To find the candidate you want to vote for, enter a part of his/her name, slogan or promotional text.': 'Typ een deel van een slogan, verkiezingstekst of naam van een kandidaat om degene op wie u wilt stemmen te vinden.',
    'This screen presents information about the selected candidate.': 'Hier vindt u informatie over de geselecteerde kandidaat.',
    'Requirements for the Excel document:': 'Het Excel-document moet voldoen aan de volgende indeling: ',
    'Click \'Parse data\'': 'Klik op de knop \'Controleren\'',
    'Select the': 'Selecteer de',
    'you want to vote for or click ‘Blank vote’ if you want to issue a blank vote': 'op wie u wilt stemmen, of klik \'Blanco stem\' om een blanco stem uit te brengen',
    'There are no elections open right now for which you have voting right.': 'Er zijn momenteel geen verkiezingen geopend waarvoor u stemrecht heeft.',
    'If you believe this to be incorrect, please contact us.': 'Als u denkt dat dit incorrect is, neem dan contact op.',
    'Download (MsExcel file)': 'Download (MsExcel)',
    'Usage history': 'Verbruiksgeschiedenis',
    'candidate': 'kandidaat',
    'party with the candidate': 'partij met de kandidaat',
    'Show parties or candidates in random order': 'Toon partijen of kandidaten in willekeurige volgorde',
    'Candidates System': 'Kandidatenstelsel',
    'Note: party- or candidates-system can not be set because the election already has parties and\/or candidates':
        'Stelselkeuze niet mogelijk: er zijn al partijen en\/of kandidaten aan de verkiezing verbonden',
    'Party System': 'Partijenstelsel',
    'Only use letters or numbers for this field': 'Alleen letters en cijfers zijn hier toegestaan',
    'If you are unable to log in, please contact us via': 'Kunt u niet inloggen, neem dan contact op via',
    'Contact us via': 'Neem contact op via',
    'Duplicate this election': 'Dupliceer deze verkiezing',
    'Logo': 'Logo',
    'MM/dd/yyyy HH:mm': 'dd-MM-yyyy HH:mm',
    'Add My Party': 'Voeg mijn partij toe',
    'Add Parties': 'Partijen toevoegen',
    'Phone': 'Telefoon',
    'Time': 'Tijd',
    'If username is filled, the candidate can edit his or her own data if logged in with this username': 'Indien de gebruikersnaam is gevuld kan de kandidaat zijn of haar eigen gegevens bewerken indien ingelogd met deze gebruikersnaam',
    'List order': 'Lijstvolgorde',
    'Majority of votes': 'Meerderheid van stemmen',
    'My candidacy data': 'Mijn kandidaatgegevens',
    'During the nomination, information about the candidate can be added via the edit button. As a candidate, you must approve your candidacy via the button \'Approve my candidacy\'': 'Tijdens de kandidaatstelling kan informatie over de kandidaat worden toegevoegd via de knop bewerken. Als kandidaat moet je je kandidaatstelling goedkeuren via de knop ‘keur mijn kandidaatstelling goed',



    confirmMakePartyAdmin(userName, partyName) {
        return `${userName} partijbeheerder maken van partij ${partyName.NL}?`;
    },
};

const enTranslatorPart: ITranslatorExceptStrings = {
    languageCode: 'EN',
    localeCode: 'en-GB',
    translate: translate,
    columnDescription: (column: string, lang: string, maxLength: number) => `${column} (${lang}, max. ${maxLength} characters)`,
    editElection: (name: Translatable) => `Edit ${name.EN}`,
    formatTurnout: (turnout: number, langCode: LocaleCode, postfix: string) =>
        `${Number(turnout.toFixed(2)).toLocaleString(langCode)}%${postfix}`,
    votingRightForElection: (electionName: Translatable) => `Voting right for ${electionName.EN}`,
    votingResultForElection: (electionName: Translatable) => `Voting results for ${electionName.EN}`,
    eraseElectionWarning: (name: Translatable) => `Are you sure you intend to erase ${name.EN}?\n\nNote: this affects related candidate / party data as well!\n\nYou will not be able to undo this action.`,
    confirmMakePartyAdmin(userName, partyName) {
        return `Make ${userName} administrator of party ${partyName.EN}?`;
    }
};

const enTranslator =
    Object.keys(nlTranslator)
        .filter(key => (nlTranslator as any)[key].constructor === String)
        .reduce((props, en) => ({ [en]: en, ...props }), enTranslatorPart) as Translator;

const languages = [enTranslator, nlTranslator];

export const getTranslator = (lang: LanguageCode) => languages.filter(t => t.languageCode === lang)[0]!;

export const getLocaleCode = (lang: LanguageCode) => getTranslator(lang).localeCode;
